import { Users, Paintbrush, MessageSquare, CheckCircle, Award } from 'lucide-react';

const reasons = [
  {
    icon: Users,
    title: 'Erfaren målerifirma',
    description: 'Med över 30 års erfarenhet och tusentals genomförda projekt vet vi exakt vad som krävs för ett perfekt resultat.',
  },
  {
    icon: Paintbrush,
    title: 'Noggrant förarbete',
    description: 'Vi skrapar, slipar och grundar ordentligt innan målning. Det är hemligheten bakom ett långvarigt resultat.',
  },
  {
    icon: Award,
    title: 'Rätt färg & metod',
    description: 'Varje fönstertyp kräver sin teknik. Vi anpassar färgval och metod efter träslag, ålder och skick.',
  },
  {
    icon: MessageSquare,
    title: 'Tydlig kommunikation',
    description: 'Du får alltid veta vad som händer, när det händer och vad det kostar. Inga överraskningar.',
  },
  {
    icon: CheckCircle,
    title: 'Slutbesiktning innan avslut',
    description: 'Vi går igenom arbetet tillsammans med dig innan vi anser oss klara. Din nöjdhet är vår prioritet.',
  },
];

export const WhyUsSection = () => {
  return (
    <section id="why-us" className="section-padding bg-[#F1F5F9]" data-testid="why-us-section">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left content */}
          <div className="lg:sticky lg:top-24">
            <span className="text-[#C0392B] font-medium text-sm uppercase tracking-wider mb-4 block">
              Varför oss
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-[#1F2937] mb-6">
              Varför välja Vi Målar för fönstermålning?
            </h2>
            <p className="text-base md:text-lg text-[#64748B] mb-8">
              Vi är ett etablerat måleriföretag i Stockholm som specialiserat oss på 
              kvalitetsarbete med fokus på kundnöjdhet. När du anlitar oss får du inte 
              bara ett snyggt resultat – du får en partner som bryr sig.
            </p>
            
            {/* Company stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white p-6 border border-[#E2E8F0]">
                <div className="stat-number">30+</div>
                <div className="text-[#64748B] font-medium mt-2">År i branschen</div>
              </div>
              <div className="bg-white p-6 border border-[#E2E8F0]">
                <div className="stat-number">1000+</div>
                <div className="text-[#64748B] font-medium mt-2">Genomförda projekt</div>
              </div>
            </div>
          </div>

          {/* Right - Reasons list */}
          <div className="space-y-6">
            {reasons.map((reason, index) => {
              const IconComponent = reason.icon;
              return (
                <div
                  key={index}
                  className="bg-white p-6 border border-[#E2E8F0] flex gap-5 animate-fade-in-up hover:shadow-md transition-shadow duration-300"
                  style={{ animationDelay: `${index * 100}ms` }}
                  data-testid={`why-us-card-${index}`}
                >
                  <div className="w-12 h-12 bg-[#2C3E50] flex items-center justify-center flex-shrink-0">
                    <IconComponent className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-heading font-semibold text-[#1F2937] mb-2">
                      {reason.title}
                    </h3>
                    <p className="text-[#64748B] text-sm leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
